import { IconButton, Tooltip } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { getActasCsvHandler, getActasCsvNotificadorHandler } from "../../handlers/actas.handler";
import { useGeneralAppStore } from "../../store/generalAppStore";
import { Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";


const ExcelButton = ({ headers, filename, estados, filterFields, actasLocale }) => {
    const path = useLocation().pathname;
    const [actasCsv, setActasCsv] = useState();
    const { loads } = useGeneralAppStore();

    const csvRef = useRef(null);


    useEffect(() => {
        if (actasCsv?.length > 0 && csvRef.current) {
            setTimeout(() => {
                csvRef.current.link.click(); // Simula el clic para descargar
            }, 500); // Pequeño delay para asegurar que se renderizó
        }
    }, [actasCsv]);

    useEffect(() => {
        setActasCsv(null);
    }, [actasLocale])

    return (
        <Tooltip title="Descargar tabla" arrow>
            <>
                {
                    actasCsv &&
                    <div className="h-100 d-flex align-items-center" >
                        <CSVLink
                            ref={csvRef}
                            style={{ textDecoration: "none" }}
                            headers={headers}
                            filename={filename}
                            data={actasCsv}
                            separator={";"}
                        // disabled={loads?.includes("actas")}
                        >
                            <IconButton className="">
                                <img
                                    src="https://webservice.muninqn.gov.ar/cglobales/assets/icons/Excel-Logo.png"
                                    alt="excel"
                                    style={{ height: 25 }}
                                />
                            </IconButton>
                        </CSVLink>
                    </div>
                }
                {!actasCsv &&
                    <IconButton
                        onClick={() => {
                            if (path.includes('/notificador/')) {
                                getActasCsvNotificadorHandler(setActasCsv, { estado_id: estados, ...filterFields })
                            } else {
                                getActasCsvHandler(setActasCsv, { estado_id: estados, filtros: filterFields })
                            }
                        }}
                    >
                        {
                            (loads.includes('get_actas_csv') || loads.includes('get_actas'))
                                ?
                                <div style={{ height: "25px", width: "25px" }} className=" d-flex justify-content-center align-items-center">
                                    <Spinner size="sm" variant="success" />
                                </div>
                                :
                                <img

                                    src="https://webservice.muninqn.gov.ar/cglobales/assets/icons/Excel-Logo.png"
                                    alt="excel"
                                    style={{ height: 25 }}
                                />
                        }

                    </IconButton>
                }
            </>
            {/* <div className="h-100 d-flex align-items-center ">
                <CSVLink
                    style={{ textDecoration: "none" }}
                    headers={headers}
                    filename={filename}
                    data={data}
                    separator={";"}
                >
                    <IconButton>
                        <img
                            src="https://webservice.muninqn.gov.ar/cglobales/assets/icons/Excel-Logo.png"
                            alt="excel"
                            style={{ height: 25 }}
                        />
                    </IconButton>
                </CSVLink>
            </div> */}
        </Tooltip>
    );
}
export default ExcelButton;